import { useEffect, useState } from 'react';
import { formatDistanceToNow } from 'date-fns';
import MiddleEllipsis from 'react-middle-ellipsis';
import { styles } from '../../constants';
import { hash } from '../../util';
import { Loading } from '../loading';
import { isRunning } from './shared';

export const Messages = ({ job }) => {
  const [messages, setMessages] = useState([]);

  const cap = 10;

  useEffect(() => {
    const l = [...(job?.progress?.messages || [])];
    const pretty = {
      visit: 'Visit',
      runCompletion: 'Ask AI',
      learnSchema: 'Generate output schema',
    };

    const now = new Date().getTime();
    const j = (job?.children || []).filter((it) => Boolean(pretty[name]));
    for (const { name, started, finished, url } of j) {
      l.push({
        loading: !finished,
        createdAt: started,
        updatedAt: finished || now,
        body: `${pretty[name]} ${url || ''}`,
      });
    }

    const seen = {};
    setMessages(
      l.filter((it) => {
        if (seen[it.body]) {
          return false;
        }
        seen[it.body] = true;
        return true;
      }),
    );
  }, [job?.progress?.messages, job?.children]);

  const borderRadius = 5;
  const nodes = messages
    .sort((a, b) => b.createdAt - a.createdAt)
    .slice(0, cap)
    .map(({ loading, createdAt, updatedAt, body }, idx) => {
      const ts = new Date();
      ts.setTime(createdAt);
      let d;
      try {
        d = formatDistanceToNow(ts, { addSuffix: true });
      } catch (e) {
        console.log(e, ts, createdAt);
        d = 'invalid';
      }
      return (
        <div
          key={idx}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 5,
            fontSize: 11,
            fontFamilyx: 'monospace',
            padding: '2px 4px',
            backgroundx: '#f8f8f8',
            borderRadius: idx == 0 ? borderRadius : 0,
          }}
        >
          {loading && <Loading size={14} />}
          <div style={{ flex: 1, ...styles.textOverflowStyle }}>
            <MiddleEllipsis>
              <span>{body}</span>
            </MiddleEllipsis>
          </div>
          <div>{d}</div>
        </div>
      );
    });

  if (!nodes.length) {
    return null;
  }

  return (
    <div style={{ fontSize: 14, border: '1px solid #ccc', background: 'white', borderRadius: 4, padding: '4px 2px' }}>
      {nodes}
    </div>
  );
};
